import { render, staticRenderFns } from "./parts3.vue?vue&type=template&id=151d09c6&scoped=true&"
import script from "./parts3.vue?vue&type=script&lang=ts&"
export * from "./parts3.vue?vue&type=script&lang=ts&"
import style0 from "./parts3.vue?vue&type=style&index=0&id=151d09c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d09c6",
  null
  
)

export default component.exports